<template>
  <span class="ui-badge" :class="normalizedTone">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'UiBadge',
  props: {
    tone: {
      type: String,
      default: ''
    }
  },
  computed: {
    normalizedTone() {
      const map = {
        'success': 'ok',
        'warning': 'warn',
        'error': 'danger',
        'info': 'info',
        'neutral': 'neutral',
        'ok': 'ok',
        'warn': 'warn',
        'danger': 'danger',
        'primary': 'ok'
      }
      return map[this.tone] || this.tone
    }
  }
}
</script>

<style scoped>
.info {
  background: rgba(23, 162, 184, 0.15);
  color: #117a8b;
}
.neutral {
  background: rgba(108, 117, 125, 0.15);
  color: #6c757d;
}
</style>
